import { Stack } from "@mui/material";
import React from "react";

const AddRoleWrapper = ({ children }) => {
  return (
    <Stack
      p={2}
      spacing={2}
      bgcolor="grey.gs"
      textAlign="right"
      width={800}
      height={400}
      sx={{ borderRadius: 2, overflow: "auto" }}
      flexDirection={"column"}
    >
      {children}
    </Stack>
  );
};

export default AddRoleWrapper;
